<template>
  <div class="auth-sidefooter">
    <img src="/src/assets/images/logo/nozzle106.png" class="img-brand img-fluid" alt="Nozzle Logo" style="width: 110px; height: auto;" />
    <hr class="mb-2 mt-2" />
    <div class="row">
      <div class="col my-1">
        <p class="m-0">Powered by <a href="https://www.nozzlesoft.com/" target="_blank" rel="noopener noreferrer" class="text-decoration-none fw-bold">NOZZLE</a> - Ship Management Software</p>
      </div>
      <div class="col-auto my-1">
        <ul class="list-inline footer-link mb-0">
          <li class="list-inline-item"><a href="https://vesproc.com/" target="_blank" rel="noopener noreferrer">Home</a></li>
          <li class="list-inline-item"><a href="mailto:support@vesproc.com">Support</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthFooter'
};
</script>

<style scoped>
.auth-sidefooter {
  margin-top: 20px;
}

.img-brand {
  margin-bottom: 10px;
}

.footer-link a {
  padding: 0;
  text-decoration: none;
  color: #212529;
  transition: color 0.3s ease;
}

.footer-link a:hover {
  color: #00A0DF;
}

.footer-link li {
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.footer-link li:first-child {
  padding-left: 0;
}

.footer-link li:last-child {
  border-right: none;
  padding-right: 0;
}
</style>

